var _g, _path, _rect, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletStake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7921_19295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06104 15.2275C8.26901 15.2275 10.0381 13.4577 10.0381 11.2505C10.0381 9.04327 8.26901 7.27344 6.06104 7.27344C3.85382 7.27344 2.08398 9.04327 2.08398 11.2505C2.08398 13.4577 3.85382 15.2275 6.06104 15.2275Z",
    fill: "#E5B910"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06147 9.75977L6.39625 10.7901H7.47964L6.60316 11.4269L6.93795 12.4573L6.06147 11.8205L5.18499 12.4573L5.51977 11.4269L4.64329 10.7901H5.72668L6.06147 9.75977Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.38672,
    y: 15.2285,
    width: 15.1128,
    height: 1.59082,
    rx: 0.79541,
    fill: "#CFA809",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6374 5.60352C16.4559 5.60352 17.1196 6.25255 17.1196 7.05305V8.76723C17.1196 9.56774 16.4559 10.2168 15.6374 10.2168H12.699C11.8805 10.2168 11.2168 9.56774 11.2168 8.76723V7.05305C11.2168 6.25255 11.8805 5.60352 12.699 5.60352H15.6374ZM14.1664 7.22523C13.9971 7.22523 13.8595 7.35979 13.8595 7.52542V8.29142C13.8595 8.46049 13.9971 8.59506 14.1664 8.59506C14.3393 8.59506 14.4769 8.46049 14.4769 8.29142V7.52542C14.4769 7.35979 14.3393 7.22523 14.1664 7.22523Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0852 5.14508V5.65575C15.9617 5.62124 15.8312 5.60399 15.6971 5.60399H15.4678V5.14508C15.4678 4.44464 14.8856 3.87531 14.1694 3.87531C13.4531 3.87531 12.871 4.44119 12.8674 5.13818V5.60399H12.6416C12.504 5.60399 12.3735 5.62124 12.25 5.6592V5.14508C12.2535 4.10994 13.1109 3.27148 14.1623 3.27148C15.2279 3.27148 16.0852 4.10994 16.0852 5.14508Z",
    fill: "#E5B910"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7921_19295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.9541,
    height: 7.9541,
    fill: "white",
    transform: "translate(2.08398 7.27344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletStake);
export default __webpack_public_path__ + "static/media/wallet-stake.be24e3427b628da1be4618f646cb13e0.svg";
export { ForwardRef as ReactComponent };